module.exports = __webpack_public_path__ + "media/images/pc/specials/okinawa_churaumi_aquarium/frame_center-d84674cf60ad3f56aeb2ce21bc3a99e8.png";